import types from './types';
import api from "../api/quiz";
import {createError, logError, logSuccess} from "../../../ui/Notify";

function getErrorMessage(errorResponse) {
  if (errorResponse.data && errorResponse.data.errors) {
    return  errorResponse.data.errors.map(({message}) => message).join(", ");
  }
  return errorResponse;
}

function requestQuestionList() {
  return {
    type: types.GET_QUESTION_LIST_REQUEST,
    isFetchingQuestions: true
  };
}

function requestQuestionListCompleted(questions) {
  return {
    type: types.GET_QUESTION_LIST_COMPLETED,
    isFetchingQuestions: false,
    questions
  };
}

function requestQuestionListError(questionsError) {
  return {
    type: types.GET_QUESTION_LIST_ERROR,
    isFetchingQuestions: false,
    questionsError
  };
}

export function getQuestions(id) {
  return dispatch => {
    dispatch(requestQuestionList());
    return api.getQuestionList(id)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestQuestionListCompleted(resp));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = getErrorMessage(err.response);
          logError(message);
          dispatch(requestQuestionListError(message));
        } else {
          logError(err);
          dispatch(requestQuestionListError(createError("Не удалось загрузить список вопросов")));
        }
      });
  };
}

function requestQuizCard() {
  return {
    type: types.GET_QUIZ_CARD_REQUEST,
    isFetchingQuizCard: true
  };
}

function requestQuizCardCompleted(quizCard) {
  return {
    type: types.GET_QUIZ_CARD_COMPLETED,
    isFetchingQuizCard: false,
    quizCard
  };
}

function requestQuizCardError(quizCardError) {
  return {
    type: types.GET_QUIZ_CARD_ERROR,
    isFetchingQuizCard: false,
    quizCardError
  };
}

export function getQuizCard(id) {
  return dispatch => {
    dispatch(requestQuizCard());
    return api.getQuizCard(id)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          const card = {
            ...resp,
            organization: resp.organization
          };
          dispatch(requestQuizCardCompleted(card));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = getErrorMessage(err.response);
          logError(message);
          dispatch(requestQuizCardError(message));
        } else {
          logError(err);
          dispatch(requestQuizCardError(createError("Не удалось загрузить карточку опроса")));
        }
      });
  };
}

function requestQuizSystem() {
  return {
    type: types.GET_QUIZ_SYSTEM_INFO_REQUEST,
    isFetchingQuizSystem: true
  };
}

function requestQuizSystemCompleted(quizSystem) {
  return {
    type: types.GET_QUIZ_SYSTEM_INFO_COMPLETED,
    isFetchingQuizSystem: false,
    quizSystem
  };
}

function requestQuizSystemError(quizSystemError) {
  return {
    type: types.GET_QUIZ_SYSTEM_INFO_ERROR,
    isFetchingQuizSystem: false,
    quizSystemError
  };
}

function requestQuizMain() {
  return {
    type: types.GET_QUIZ_MAIN_REQUEST,
    isFetchingQuizMain: true
  };
}

function requestQuizMainCompleted(quizMain) {
  return {
    type: types.GET_QUIZ_MAIN_COMPLETED,
    isFetchingQuizMain: false,
    quizMain
  };
}

function requestQuizMainError(quizMainError) {
  return {
    type: types.GET_QUIZ_MAIN_ERROR,
    isFetchingQuizMain: false,
    quizMainError
  };
}

export function getQuizMain(id) {
  return dispatch => {
    dispatch(requestQuizMain());
    return api.getQuizMainInfo(id)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestQuizMainCompleted(resp));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = getErrorMessage(err.response);
          logError(message);
          dispatch(requestQuizMainError(message));
        } else {
          logError(err);
          dispatch(requestQuizMainError(createError("Не удалось загрузить данные опроса")));
        }
      });
  };
}



export default {
  getQuestions,
  getQuizCard,
  getQuizMain
}
